<template>
    <div class="modal fade" id="modalNotLoggedIn" tabindex="-1" role="dialog"
         aria-labelledby="modalNotLoggedInTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">

            <div class="modal-content">

                <div class="modal-header">
                    <button type="button" class="close" aria-label="Close" data-dismiss="modal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body text-center d-flex flex-column justify-content-center">

                    <p>{{ translate.home.needToLogin }}</p>

                    <a :href="regionRelativeUrl('/users/login/')" class="btn btn-primary">{{ translate.login.login }}</a>

                    <a :href="regionRelativeUrl('/users/registration/')" class="btn btn-outline-secondary mt-3">{{ translate.home.registerNow }}</a>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";

export default {
    beforeDestroy() {
        window.clearModalFade();
    },
    computed: {
        ...mapState(['translate']),
    },
    mixins: [
        regionsUrlMixin,
    ],
};
</script>
